import styled from 'styled-components/macro';

import { OrderActionAdditionalInfoText } from '../../../common/fontElements';

export const StepTitle = styled(OrderActionAdditionalInfoText)`
  padding: 10px 0;
  font-size: 12px;
`;

export const Subtext = styled.span`
  opacity: 0.9;
  color: #7f7f7f;
`;
